import { Img } from "react-image"
const images = {
  "domotica": "uploads/domotica.png",
  "netwerk": "uploads/netwerk.png",
  "elek": "uploads/elektriciteitswerken.jpg"
};
const url = process.env.REACT_APP_PRODUCTION_FRONTEND;
export default function ServiceCard({title,description,img}){
return(
     <div
            className="my-card"
          >

            <div className="inner-card">
              <div className="image-wrapper">
                <Img
                  fill="true"
                  src={url+images[img]}
                  alt="test"
                  style={{
                    display: "inline-flex",
                    objectFit: "cover",
                    width: "inherit",
                    height: 230,
                  }}
                />
              </div>
              <div style={{ padding: "1.5rem" }}>
                <div style={{ marginBottom: "0.75rem" }}>
                  <span className="title-card">
                    <span className="title">{title}</span>
                  </span>
                </div>
                <p id="bodytext" className="text-indigo-200/65">
                  {description}
                </p>
              </div>
            </div>
          </div>
)
}